import { useParams } from "react-router-dom";
import { useGetWeatherStationSummaryByDateQuery } from "../../../api/rtk/weatherStations/slices/weatherStationsApiSlice";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import HourMeasurementItem from "./HourMeasurementItem";
import { formatDateToISO8601 } from "../../../shared/format/date";
import { useHorizontalWheelScroll } from "../../../shared/hooks/useHorizontalWheelScroll";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setHour } from "../../../stateManagement/reducers/services/weatherStations/WeatherStationsSlice";
import { useAuthWeatherStationsService } from "../../../hooks/auth/useAuthWeatherStationsService";

export function HourMeasurementList() {
    const dispatch = useDispatch();
    const { stationId } = useParams();
    const containerRef = useRef<HTMLDivElement>(null);
    const activeRef = useRef<HTMLButtonElement | null>(null);
    useAuthWeatherStationsService();
    const token = useAppSelector(state => state.auth.tokens.services?.weatherStations);
    const { date, hour: selectedHour } = useAppSelector(state => state.weatherStationsService)
    const { data: hourMeasurements } = useGetWeatherStationSummaryByDateQuery({ date: formatDateToISO8601(date), stationId, timezone: 'Asia/Tomsk' }, { skip: !token || !stationId || !date })

    const onWheel = useHorizontalWheelScroll({ speed: 0.65 });
    useEffect(() => {
        // когда меняется выбранный час или дата, прокручиваем к нему
        activeRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "nearest", // по вертикали не трогаем
            inline: "center", // выравниваем по центру горизонтально
        });
    }, [selectedHour, date]);

    useEffect(() => {
        const notNullHourMeasurement = hourMeasurements?.findLast((measurement) => measurement.temperature != null);
        if (notNullHourMeasurement) {
            dispatch(setHour(notNullHourMeasurement?.hour))
        }
    }, [hourMeasurements])

    return (
        <div className="hour-measurement-list-div" ref={containerRef} onWheel={onWheel}>
            {hourMeasurements && hourMeasurements.map((hourMeasurement: any) => {
                return <HourMeasurementItem activeRef={selectedHour === hourMeasurement?.hour ? activeRef : undefined} data={hourMeasurement} />
            })}
        </div>
    )
}
